import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  IconButton,
  Typography,
  Box,
  Divider,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Buttons from '../../../../mis-datos/components/common/Buttons';
import ProductModalImage from './ProductModalImage';
import ProductModalDescription from './ProductModalDescription';
import { useProductModalStyles } from './styles';
import { setOpenProductModal } from '../../../../../../redux/actions/BankActions';
import DetailTabs from '../../exchange/DetailTabs';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    fontWeight: 600,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h2" className={classes.title}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(() => ({
  root: {
    margin: 0,
    justifyContent: 'center',
  },
}))(MuiDialogActions);

const ProductCardModal = ({ ...props }) => {
  const { product, category, open, onClose, mobile } = props;
  const { newExchange } = useSelector((state) => state.bankReducer);
  const classes = useProductModalStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const goToExchanges = () => {
    dispatch(setOpenProductModal(false));
    history.push('/mis-puntos/canjes');
  };

  const isGiftCard = () => newExchange.category === 'gift-card';

  const getTitle = (productCategory) => {
    switch (productCategory) {
      case 'gift-card':
        return 'GiftCard';

      case 'estadiocdf':
        return 'Estadio CDF';

      case 'pizzahut':
        return 'PizzaHut';

      case 'pedidosya':
        return 'Pedidos Ya';

      case 'getaway':
        return 'Getaway';

      case 'rappi':
        return 'Rappi';

      case 'telepizza':
        return 'TelePizza';

      case 'cinepolis':
        return 'Cinepolis';

      default:
        return 'GiftCard';
    }
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="product-dialog-title"
        open={open}
        maxWidth={'md'}
        disableBackdropClick
        disableEscapeKeyDown
      >
        {product && (
          <>
            <DialogTitle
              className={classes.titleContainer}
              id="product-dialog-title"
              onClose={onClose}
            >
              {!isGiftCard()
                ? `!Has canjeado con éxito tus Ripley Puntos Go por ${getTitle(
                    newExchange.category,
                  )}`
                : `Ahora puedes comenzar a usar tu GitfCard!`}
            </DialogTitle>
            <DialogContent dividers>
              <Box display="flex" flexDirection="column" width="100%">
                <Box className={classes.container}>
                  <ProductModalImage src={product.image} mobile={mobile} />
                  <ProductModalDescription
                    product={product}
                    mobile={mobile}
                    isGiftCard={isGiftCard()}
                    newExchange={newExchange}
                  />{' '}
                </Box>
                <Divider className={classes.divider} />
                <DetailTabs
                  row={newExchange}
                  instructions={category}
                  mobile={false}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Buttons
                disabled={false}
                modifiable={true}
                loading={false}
                error={false}
                onCancelClick={onClose}
                onSendClick={goToExchanges}
                mobile={mobile}
                primaryButtonText={'Ir a Canjes'}
                secondaryButtonText={'Cerrar'}
                marginRightButton={20}
              />
            </DialogActions>
          </>
        )}
      </Dialog>
    </div>
  );
};

ProductCardModal.propTypes = {
  product: PropTypes.object.required,
  category: PropTypes.object.required,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  mobile: PropTypes.bool,
};

export default ProductCardModal;
